export default function (props: any) {
    return (
        <svg
            width="42px"
            height="42px"
            viewBox="0 0 42 42"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="dark" transform="translate(-191.000000, -97.000000)">
                    <g id="编组" transform="translate(185.000000, 91.000000)">
                        <rect id="Rectangle-Copy" stroke="#979797" opacity="0" x="0.5" y="0.5" width="53" height="53"></rect>
                        <g id="Group-2" transform="translate(7.000000, 7.000000)">
                            <circle id="Oval" stroke="#FFFFFF" strokeWidth="1.5" cx="20" cy="20" r="20"></circle>
                            <path
                                d="M20,3 L20,4 M32.0208153,7.97918472 L31.3137085,8.6862915 M37,20 L36,20 M32.0208153,32.0208153 L31.3137085,31.3137085 M20,37 L20,36 M7.97918472,32.0208153 L8.6862915,31.3137085 M3,20 L4,20 M7.97918472,7.97918472 L8.6862915,8.6862915"
                                id="Combined-Shape"
                                stroke="#FFFFFF"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            ></path>
                            <path
                                d="M23.2003588,11.1279121 L23.2852635,11.1359656 C23.5569517,11.1853634 23.7371536,11.4456551 23.6877558,11.7173433 L23.6877558,11.7173433 L22.3632723,18.9998912 L25.8697241,19 C25.9630114,19 26.0537868,19.026078 26.1321717,19.0744149 L26.2060605,19.13003 C26.4103894,19.3157834 26.4254476,19.6320076 26.2396942,19.8363364 L26.2396942,19.8363364 L18.1741492,28.7084359 C18.0581075,28.8360818 17.8844623,28.8948937 17.7147365,28.8640344 C17.4430483,28.8146366 17.2628464,28.5543449 17.3122442,28.2826567 L17.3122442,28.2826567 L18.6352723,20.9998912 L15.1302759,21 C15.0369886,21 14.9462132,20.973922 14.8678283,20.9255851 L14.7939395,20.86997 C14.5896106,20.6842166 14.5745524,20.3679924 14.7603058,20.1636636 L14.7603058,20.1636636 L22.8258508,11.2915641 C22.9418925,11.1639182 23.1155377,11.1051063 23.2852635,11.1359656 Z"
                                id="Combined-Shape"
                                fill="#FFFFFF"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
